module.exports = __webpack_public_path__ + "img/cs-4.40587b9f.png";